/* ==========================================================
   J: sökikonen öppnar sök vid click
   ========================================================== */

document.addEventListener('DOMContentLoaded', function() {
  const searchButton = document.querySelector('.js-open-search');
  const searchInput = document.querySelector('.js-predictive-search-input');
  
  if (searchButton && searchInput) {
    searchButton.addEventListener('click', () => {
      searchInput.focus();
      searchInput.dispatchEvent(new Event('focus'));
    });
  }
});

/* ==========================================================
   JAKOB: INVENTORY-TEXT FIX — "Slutsålt" → "Tillfälligt slut"
   ========================================================== */

document.addEventListener("DOMContentLoaded", function() {

  function replaceSoldOutText() {
    const containers = document.querySelectorAll('#inventory-info-app, .iia-container');
    containers.forEach(container => {
      const elements = container.querySelectorAll('*');
      elements.forEach(el => {
        const text = el.textContent.trim();
        if (text === 'Slutsålt') {
          el.textContent = 'Tillfälligt slut';
        }
      });
    });
  }
});



/* ==========================================================
   JAKOB: Gradient för inspirations "läs mer"
   ========================================================== */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".page-description--truncate").forEach(function (el) {
    if (el.scrollHeight > el.clientHeight + 10) {
      el.classList.add("truncate--overflow");
    }
  });
});


setInterval(function() {
  if (typeof taxSelectorobserver !== "undefined") {
      taxSelectorobserver.observe(document.querySelector("body"), {
          characterData: false,
          childList: true,
          attributes: false,
          subtree: true,
      });
  }
}, 100);

 

/* ==========================================================
  Tvingar fram headern vid köp (endast mobil + tablet)
   ========================================================== 
(() => {
  const isMobileOrTablet = matchMedia('(max-width: 1024px)').matches;
  if (!isMobileOrTablet) return; // kör inte på desktop

  addEventListener('click', e => {
    if (!e.isTrusted) return;
    const b = e.target.closest('.js-ga-event,.product-form__button');
    if (!b) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    scrollBy(0, -65);
    dispatchEvent(new Event('scroll'));

    setTimeout(() => {
      b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }, 600);
  }, true);
})();*/


/* ==========================================================
  Force header on add-to-cart (mobile + tablet, Panagora-safe)
  - Normal products: scroll efter submit
  - Pre-order: scroll EN gång när modalens add-knapp triggas Tester och fix med Add to cart knappen för Leveransinfo
   ========================================================== 
(() => {
  const isMobileOrTablet = matchMedia('(max-width: 1024px)').matches;
  if (!isMobileOrTablet) return;

  const doScroll = () => {
    scrollBy(0, -65);
    dispatchEvent(new Event('scroll'));
  };

  // Vanliga produkter
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-product-form]');
     setTimeout(doScroll, 150);
    if (!form) return;
    const isPreOrder = form.dataset.preOrder === 'true';
    if (isPreOrder) return; // hoppa över, modal tar hand om detta
   
  });

  //  Pre-order modal
  let modalClicked = false;
  document.addEventListener(
    'click',
    e => {
      const btn = e.target.closest('.pre-order-modal__add-button');
      if (!btn || modalClicked) return; // kör bara första gången
      modalClicked = true;
      // vänta tills Panagoras addItemFromForm kört klart
      setTimeout(() => {
        doScroll();
        // nollställ efter kort stund så nästa produkt kan scrolla igen
        setTimeout(() => (modalClicked = false), 1000);
      }, 250);
    },
    true // capture-fas så vi kör före deras bubbler-kopia
  );
})();
*/